import { render, staticRenderFns } from "./FormModal2.vue?vue&type=template&id=459bc7bf&scoped=true"
import script from "./FormModal2.vue?vue&type=script&lang=js"
export * from "./FormModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459bc7bf",
  null
  
)

export default component.exports